@file:OptIn(InternalResourceApi::class)

package swetgram.shared.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/swetgram.shared.generated.resources/"

@delegate:ResourceContentHash(347_337_000)
internal val Res.string.groups_list_error_load_more: StringResource by lazy {
      StringResource("string:groups_list_error_load_more", "groups_list_error_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 256, 131),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 188, 71),
      ))
    }

@delegate:ResourceContentHash(1_484_188_035)
internal val Res.string.groups_list_error_search: StringResource by lazy {
      StringResource("string:groups_list_error_search", "groups_list_error_search", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 491, 100),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 327, 64),
      ))
    }

@delegate:ResourceContentHash(1_712_546_520)
internal val Res.string.groups_list_new_group: StringResource by lazy {
      StringResource("string:groups_list_new_group", "groups_list_new_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 592, 61),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 392, 41),
      ))
    }

@delegate:ResourceContentHash(-191_919_335)
internal val Res.string.groups_list_search_empty_body: StringResource by lazy {
      StringResource("string:groups_list_search_empty_body", "groups_list_search_empty_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 654, 125),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 434, 69),
      ))
    }

@delegate:ResourceContentHash(2_132_735_283)
internal val Res.string.groups_list_title: StringResource by lazy {
      StringResource("string:groups_list_title", "groups_list_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_groups_list.commonMain.cvr", 780, 41),
        ResourceItem(setOf(), "${MD}values/strings_groups_list.commonMain.cvr", 504, 33),
      ))
    }

@delegate:ResourceContentHash(-917_756_832)
internal val Res.string.handle_prefixed: StringResource by lazy {
      StringResource("string:handle_prefixed", "handle_prefixed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6321, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4567, 31),
      ))
    }

@delegate:ResourceContentHash(-2_096_551_784)
internal val Res.string.link_error_body: StringResource by lazy {
      StringResource("string:link_error_body", "link_error_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_links.commonMain.cvr", 10, 183),
        ResourceItem(setOf(), "${MD}values/strings_links.commonMain.cvr", 10, 107),
      ))
    }

@delegate:ResourceContentHash(1_792_942_161)
internal val Res.string.link_error_title: StringResource by lazy {
      StringResource("string:link_error_title", "link_error_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_links.commonMain.cvr", 194, 88),
        ResourceItem(setOf(), "${MD}values/strings_links.commonMain.cvr", 118, 56),
      ))
    }

@delegate:ResourceContentHash(-1_299_692_639)
internal val Res.string.link_loading: StringResource by lazy {
      StringResource("string:link_loading", "link_loading", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_links.commonMain.cvr", 283, 68),
        ResourceItem(setOf(), "${MD}values/strings_links.commonMain.cvr", 175, 40),
      ))
    }

@delegate:ResourceContentHash(655_849_970)
internal val Res.string.link_title: StringResource by lazy {
      StringResource("string:link_title", "link_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_links.commonMain.cvr", 352, 46),
        ResourceItem(setOf(), "${MD}values/strings_links.commonMain.cvr", 216, 38),
      ))
    }

@delegate:ResourceContentHash(-1_878_367_492)
internal val Res.string.moderation_action_desc_block_user: StringResource by lazy {
      StringResource("string:moderation_action_desc_block_user", "moderation_action_desc_block_user", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6353, 305),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4599, 153),
      ))
    }

@delegate:ResourceContentHash(1_197_304_661)
internal val Res.string.moderation_action_desc_delete_message: StringResource by lazy {
      StringResource("string:moderation_action_desc_delete_message", "moderation_action_desc_delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6659, 281),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4753, 145),
      ))
    }

@delegate:ResourceContentHash(-1_614_217_822)
internal val Res.string.moderation_action_desc_delete_permanent: StringResource by lazy {
      StringResource("string:moderation_action_desc_delete_permanent", "moderation_action_desc_delete_permanent", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 6941, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4899, 63),
      ))
    }

@delegate:ResourceContentHash(1_923_167_275)
internal val Res.string.moderation_action_desc_delete_post: StringResource by lazy {
      StringResource("string:moderation_action_desc_delete_post", "moderation_action_desc_delete_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7041, 214),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4963, 122),
      ))
    }

@delegate:ResourceContentHash(720_948_932)
internal val Res.string.moderation_confirm_head_block: StringResource by lazy {
      StringResource("string:moderation_confirm_head_block", "moderation_confirm_head_block", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7256, 321),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5086, 181),
      ))
    }

@delegate:ResourceContentHash(-1_365_435_384)
internal val Res.string.moderation_confirm_head_delete_account: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_account", "moderation_confirm_head_delete_account", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7578, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5268, 90),
      ))
    }

@delegate:ResourceContentHash(-1_793_965_967)
internal val Res.string.moderation_confirm_head_delete_comment: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_comment", "moderation_confirm_head_delete_comment", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7685, 118),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5359, 90),
      ))
    }

@delegate:ResourceContentHash(2_113_182_442)
internal val Res.string.moderation_confirm_head_delete_group: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_group", "moderation_confirm_head_delete_group", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7804, 104),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5450, 88),
      ))
    }

@delegate:ResourceContentHash(-1_418_042_058)
internal val Res.string.moderation_confirm_head_delete_message: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_message", "moderation_confirm_head_delete_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 7909, 114),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5539, 90),
      ))
    }

@delegate:ResourceContentHash(-1_994_458_474)
internal val Res.string.moderation_confirm_head_delete_post: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_post", "moderation_confirm_head_delete_post", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8024, 103),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5630, 83),
      ))
    }

@delegate:ResourceContentHash(-1_684_480_643)
internal val Res.string.moderation_confirm_head_delete_unknown: StringResource by lazy {
      StringResource("string:moderation_confirm_head_delete_unknown", "moderation_confirm_head_delete_unknown", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8128, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5714, 98),
      ))
    }

@delegate:ResourceContentHash(-1_089_771_466)
internal val Res.string.moderation_confirm_head_none: StringResource by lazy {
      StringResource("string:moderation_confirm_head_none", "moderation_confirm_head_none", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8251, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5813, 64),
      ))
    }

@delegate:ResourceContentHash(1_222_244_527)
internal val Res.string.moderation_confirm_tail_reject: StringResource by lazy {
      StringResource("string:moderation_confirm_tail_reject", "moderation_confirm_tail_reject", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8360, 190),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5878, 118),
      ))
    }

@delegate:ResourceContentHash(868_213_101)
internal val Res.string.moderation_confirm_tail_resolve: StringResource by lazy {
      StringResource("string:moderation_confirm_tail_resolve", "moderation_confirm_tail_resolve", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8551, 187),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5997, 115),
      ))
    }

@delegate:ResourceContentHash(1_736_875_311)
internal val Res.string.mute_choice_eight_hours: StringResource by lazy {
      StringResource("string:mute_choice_eight_hours", "mute_choice_eight_hours", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8739, 55),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6113, 47),
      ))
    }

@delegate:ResourceContentHash(31_473_913)
internal val Res.string.mute_choice_forever: StringResource by lazy {
      StringResource("string:mute_choice_forever", "mute_choice_forever", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8795, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6161, 59),
      ))
    }

@delegate:ResourceContentHash(1_954_090_106)
internal val Res.string.mute_choice_one_day: StringResource by lazy {
      StringResource("string:mute_choice_one_day", "mute_choice_one_day", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8847, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6221, 39),
      ))
    }

@delegate:ResourceContentHash(1_147_284_449)
internal val Res.string.mute_choice_one_hour: StringResource by lazy {
      StringResource("string:mute_choice_one_hour", "mute_choice_one_hour", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8895, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6261, 44),
      ))
    }

@delegate:ResourceContentHash(-761_537_882)
internal val Res.string.mute_choice_one_week: StringResource by lazy {
      StringResource("string:mute_choice_one_week", "mute_choice_one_week", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 8944, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6306, 44),
      ))
    }

@delegate:ResourceContentHash(-895_467_387)
internal val Res.string.mute_status_indefinite: StringResource by lazy {
      StringResource("string:mute_status_indefinite", "mute_status_indefinite", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9001, 86),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6351, 38),
      ))
    }

@delegate:ResourceContentHash(-1_185_335_992)
internal val Res.string.mute_status_until_date: StringResource by lazy {
      StringResource("string:mute_status_until_date", "mute_status_until_date", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9088, 106),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6390, 62),
      ))
    }

@delegate:ResourceContentHash(1_312_297_816)
internal val Res.string.mute_status_until_today: StringResource by lazy {
      StringResource("string:mute_status_until_today", "mute_status_until_today", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9195, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6453, 55),
      ))
    }

@delegate:ResourceContentHash(44_189_072)
internal val Res.string.mute_status_until_yesterday: StringResource by lazy {
      StringResource("string:mute_status_until_yesterday", "mute_status_until_yesterday", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings.commonMain.cvr", 9295, 143),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 6509, 75),
      ))
    }

@delegate:ResourceContentHash(-7_409_848)
internal val Res.string.notifications_discover: StringResource by lazy {
      StringResource("string:notifications_discover", "notifications_discover", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1201, 70),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 972, 54),
      ))
    }

@delegate:ResourceContentHash(1_818_939_664)
internal val Res.string.notifications_discover_preview: StringResource by lazy {
      StringResource("string:notifications_discover_preview", "notifications_discover_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1086, 114),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 905, 66),
      ))
    }

@delegate:ResourceContentHash(650_331_358)
internal val Res.string.notifications_groups: StringResource by lazy {
      StringResource("string:notifications_groups", "notifications_groups", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1272, 68),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1027, 48),
      ))
    }

@delegate:ResourceContentHash(-2_119_532_468)
internal val Res.string.notifications_mentions: StringResource by lazy {
      StringResource("string:notifications_mentions", "notifications_mentions", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1341, 58),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1076, 42),
      ))
    }

@delegate:ResourceContentHash(-1_775_450_956)
internal val Res.string.notifications_message_preview: StringResource by lazy {
      StringResource("string:notifications_message_preview", "notifications_message_preview", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1400, 105),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1119, 61),
      ))
    }

@delegate:ResourceContentHash(1_483_187_980)
internal val Res.string.notifications_messages: StringResource by lazy {
      StringResource("string:notifications_messages", "notifications_messages", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1506, 74),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1181, 50),
      ))
    }

@delegate:ResourceContentHash(1_796_747_229)
internal val Res.string.notifications_retry: StringResource by lazy {
      StringResource("string:notifications_retry", "notifications_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1581, 51),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1232, 39),
      ))
    }

@delegate:ResourceContentHash(-2_049_320_666)
internal val Res.string.notifications_security: StringResource by lazy {
      StringResource("string:notifications_security", "notifications_security", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1781, 90),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1368, 50),
      ))
    }

@delegate:ResourceContentHash(-1_540_577_873)
internal val Res.string.notifications_security_note: StringResource by lazy {
      StringResource("string:notifications_security_note", "notifications_security_note", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1633, 147),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1272, 95),
      ))
    }

@delegate:ResourceContentHash(-1_962_504_535)
internal val Res.string.notifications_streaks: StringResource by lazy {
      StringResource("string:notifications_streaks", "notifications_streaks", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1872, 77),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1419, 57),
      ))
    }

@delegate:ResourceContentHash(975_773_952)
internal val Res.string.notifications_title: StringResource by lazy {
      StringResource("string:notifications_title", "notifications_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 1950, 59),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1477, 47),
      ))
    }

@delegate:ResourceContentHash(178_579_505)
internal val Res.string.notifications_unavailable: StringResource by lazy {
      StringResource("string:notifications_unavailable", "notifications_unavailable", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_profile.commonMain.cvr", 2010, 117),
        ResourceItem(setOf(), "${MD}values/strings_profile.commonMain.cvr", 1525, 85),
      ))
    }

@delegate:ResourceContentHash(1_998_980_924)
internal val Res.string.picso_action_archive: StringResource by lazy {
      StringResource("string:picso_action_archive", "picso_action_archive", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 10, 60),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 10, 40),
      ))
    }

@delegate:ResourceContentHash(1_495_328_911)
internal val Res.string.picso_action_delete: StringResource by lazy {
      StringResource("string:picso_action_delete", "picso_action_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 71, 63),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 51, 43),
      ))
    }

@delegate:ResourceContentHash(-1_623_726_453)
internal val Res.string.picso_action_reply: StringResource by lazy {
      StringResource("string:picso_action_reply", "picso_action_reply", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 135, 62),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 95, 46),
      ))
    }

@delegate:ResourceContentHash(-1_109_230_399)
internal val Res.string.picso_action_save: StringResource by lazy {
      StringResource("string:picso_action_save", "picso_action_save", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 249, 49),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 177, 33),
      ))
    }

@delegate:ResourceContentHash(80_321_023)
internal val Res.string.picso_action_saved: StringResource by lazy {
      StringResource("string:picso_action_saved", "picso_action_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 198, 50),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 142, 34),
      ))
    }

@delegate:ResourceContentHash(1_208_063_878)
internal val Res.string.picso_add_reaction: StringResource by lazy {
      StringResource("string:picso_add_reaction", "picso_add_reaction", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 299, 54),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 211, 46),
      ))
    }

@delegate:ResourceContentHash(-1_590_058_229)
internal val Res.string.picso_analytics_title: StringResource by lazy {
      StringResource("string:picso_analytics_title", "picso_analytics_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 354, 65),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 258, 49),
      ))
    }

@delegate:ResourceContentHash(-619_555_188)
internal val Res.string.picso_analytics_unique_views: StringResource by lazy {
      StringResource("string:picso_analytics_unique_views", "picso_analytics_unique_views", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 420, 96),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 308, 64),
      ))
    }

@delegate:ResourceContentHash(-1_678_403_402)
internal val Res.string.picso_archive_empty: StringResource by lazy {
      StringResource("string:picso_archive_empty", "picso_archive_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 517, 83),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 373, 59),
      ))
    }

@delegate:ResourceContentHash(1_998_980_924)
internal val Res.string.picso_archive_title: StringResource by lazy {
      StringResource("string:picso_archive_title", "picso_archive_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 601, 59),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 433, 39),
      ))
    }

@delegate:ResourceContentHash(1_460_280_243)
internal val Res.string.picso_button_snap: StringResource by lazy {
      StringResource("string:picso_button_snap", "picso_button_snap", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 661, 53),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 473, 41),
      ))
    }

@delegate:ResourceContentHash(-347_039_336)
internal val Res.string.picso_cancel: StringResource by lazy {
      StringResource("string:picso_cancel", "picso_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 715, 36),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 515, 28),
      ))
    }

@delegate:ResourceContentHash(-1_857_626_839)
internal val Res.string.picso_caption_placeholder: StringResource by lazy {
      StringResource("string:picso_caption_placeholder", "picso_caption_placeholder", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 752, 81),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 544, 65),
      ))
    }

@delegate:ResourceContentHash(-538_194_959)
internal val Res.string.picso_close: StringResource by lazy {
      StringResource("string:picso_close", "picso_close", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 834, 39),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 610, 27),
      ))
    }

@delegate:ResourceContentHash(-1_255_212_725)
internal val Res.string.picso_confirm_delete: StringResource by lazy {
      StringResource("string:picso_confirm_delete", "picso_confirm_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 874, 88),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 638, 60),
      ))
    }

@delegate:ResourceContentHash(1_076_030_241)
internal val Res.string.picso_daily_limit_sub: StringResource by lazy {
      StringResource("string:picso_daily_limit_sub", "picso_daily_limit_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 963, 117),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 699, 85),
      ))
    }

@delegate:ResourceContentHash(447_975_148)
internal val Res.string.picso_daily_limit_title: StringResource by lazy {
      StringResource("string:picso_daily_limit_title", "picso_daily_limit_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1081, 75),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 785, 47),
      ))
    }

@delegate:ResourceContentHash(-1_435_136_842)
internal val Res.string.picso_empty_feed: StringResource by lazy {
      StringResource("string:picso_empty_feed", "picso_empty_feed", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1346, 56),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 958, 44),
      ))
    }

@delegate:ResourceContentHash(-179_650_154)
internal val Res.string.picso_empty_feed_sub: StringResource by lazy {
      StringResource("string:picso_empty_feed_sub", "picso_empty_feed_sub", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1157, 188),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 833, 124),
      ))
    }

@delegate:ResourceContentHash(-1_281_333_675)
internal val Res.string.picso_error_expired: StringResource by lazy {
      StringResource("string:picso_error_expired", "picso_error_expired", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1403, 83),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1003, 59),
      ))
    }

@delegate:ResourceContentHash(-1_908_578_325)
internal val Res.string.picso_error_limit_reached: StringResource by lazy {
      StringResource("string:picso_error_limit_reached", "picso_error_limit_reached", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1487, 117),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1063, 93),
      ))
    }

@delegate:ResourceContentHash(1_657_344_804)
internal val Res.string.picso_error_load: StringResource by lazy {
      StringResource("string:picso_error_load", "picso_error_load", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1605, 84),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1157, 52),
      ))
    }

@delegate:ResourceContentHash(-1_844_355_229)
internal val Res.string.picso_load_more: StringResource by lazy {
      StringResource("string:picso_load_more", "picso_load_more", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1690, 59),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1210, 35),
      ))
    }

@delegate:ResourceContentHash(786_838_480)
internal val Res.string.picso_more: StringResource by lazy {
      StringResource("string:picso_more", "picso_more", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1750, 58),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1246, 34),
      ))
    }

@delegate:ResourceContentHash(-320_953_935)
internal val Res.string.picso_no_chats: StringResource by lazy {
      StringResource("string:picso_no_chats", "picso_no_chats", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1809, 126),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1281, 74),
      ))
    }

@delegate:ResourceContentHash(-1_673_822_495)
internal val Res.string.picso_open_shared: StringResource by lazy {
      StringResource("string:picso_open_shared", "picso_open_shared", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1936, 57),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1356, 41),
      ))
    }

@delegate:ResourceContentHash(-1_118_624_472)
internal val Res.string.picso_publish_button: StringResource by lazy {
      StringResource("string:picso_publish_button", "picso_publish_button", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 1994, 68),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1398, 44),
      ))
    }

@delegate:ResourceContentHash(-1_031_587_744)
internal val Res.string.picso_react_title: StringResource by lazy {
      StringResource("string:picso_react_title", "picso_react_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2063, 45),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1443, 37),
      ))
    }

@delegate:ResourceContentHash(-1_403_023_433)
internal val Res.string.picso_reactions_count: StringResource by lazy {
      StringResource("string:picso_reactions_count", "picso_reactions_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2109, 57),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1481, 49),
      ))
    }

@delegate:ResourceContentHash(-1_806_178_380)
internal val Res.string.picso_refresh: StringResource by lazy {
      StringResource("string:picso_refresh", "picso_refresh", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2167, 45),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1531, 33),
      ))
    }

@delegate:ResourceContentHash(-108_146_430)
internal val Res.string.picso_remaining_time: StringResource by lazy {
      StringResource("string:picso_remaining_time", "picso_remaining_time", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2213, 56),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1565, 40),
      ))
    }

@delegate:ResourceContentHash(636_149_105)
internal val Res.string.picso_remove_reaction: StringResource by lazy {
      StringResource("string:picso_remove_reaction", "picso_remove_reaction", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2270, 73),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1606, 57),
      ))
    }

@delegate:ResourceContentHash(-670_978_253)
internal val Res.string.picso_report: StringResource by lazy {
      StringResource("string:picso_report", "picso_report", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2344, 52),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1664, 28),
      ))
    }

@delegate:ResourceContentHash(1_748_648_122)
internal val Res.string.picso_retake_button: StringResource by lazy {
      StringResource("string:picso_retake_button", "picso_retake_button", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2397, 51),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1693, 35),
      ))
    }

@delegate:ResourceContentHash(1_985_367_554)
internal val Res.string.picso_retry: StringResource by lazy {
      StringResource("string:picso_retry", "picso_retry", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2449, 43),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1729, 27),
      ))
    }

@delegate:ResourceContentHash(1_332_890_138)
internal val Res.string.picso_reward_posted: StringResource by lazy {
      StringResource("string:picso_reward_posted", "picso_reward_posted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2493, 83),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1757, 67),
      ))
    }

@delegate:ResourceContentHash(-1_454_989_534)
internal val Res.string.picso_reward_reacted: StringResource by lazy {
      StringResource("string:picso_reward_reacted", "picso_reward_reacted", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2577, 100),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1825, 72),
      ))
    }

@delegate:ResourceContentHash(-1_293_030_055)
internal val Res.string.picso_share: StringResource by lazy {
      StringResource("string:picso_share", "picso_share", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2727, 43),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1943, 31),
      ))
    }

@delegate:ResourceContentHash(-2_036_159_741)
internal val Res.string.picso_shared_message: StringResource by lazy {
      StringResource("string:picso_shared_message", "picso_shared_message", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2678, 48),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1898, 44),
      ))
    }

@delegate:ResourceContentHash(187_871_443)
internal val Res.string.picso_stat_unique: StringResource by lazy {
      StringResource("string:picso_stat_unique", "picso_stat_unique", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2771, 73),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 1975, 45),
      ))
    }

@delegate:ResourceContentHash(-1_076_222_659)
internal val Res.string.picso_stat_views: StringResource by lazy {
      StringResource("string:picso_stat_views", "picso_stat_views", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2845, 48),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2021, 32),
      ))
    }

@delegate:ResourceContentHash(992_571_276)
internal val Res.string.picso_streak_badge: StringResource by lazy {
      StringResource("string:picso_streak_badge", "picso_streak_badge", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2894, 46),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2054, 42),
      ))
    }

@delegate:ResourceContentHash(9_125_720)
internal val Res.string.picso_tab_all: StringResource by lazy {
      StringResource("string:picso_tab_all", "picso_tab_all", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2941, 37),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2097, 33),
      ))
    }

@delegate:ResourceContentHash(-1_133_993_352)
internal val Res.string.picso_tab_friends: StringResource by lazy {
      StringResource("string:picso_tab_friends", "picso_tab_friends", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 2979, 41),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2131, 37),
      ))
    }

@delegate:ResourceContentHash(-1_809_770_695)
internal val Res.string.picso_tab_saved: StringResource by lazy {
      StringResource("string:picso_tab_saved", "picso_tab_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3021, 47),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2169, 31),
      ))
    }

@delegate:ResourceContentHash(1_785_886_477)
internal val Res.string.picso_task_post_body: StringResource by lazy {
      StringResource("string:picso_task_post_body", "picso_task_post_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3069, 152),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2201, 96),
      ))
    }

@delegate:ResourceContentHash(2_100_305_361)
internal val Res.string.picso_task_post_title: StringResource by lazy {
      StringResource("string:picso_task_post_title", "picso_task_post_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3222, 93),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2298, 49),
      ))
    }

@delegate:ResourceContentHash(2_035_920_784)
internal val Res.string.picso_task_react_body: StringResource by lazy {
      StringResource("string:picso_task_react_body", "picso_task_react_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3316, 125),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2348, 89),
      ))
    }

@delegate:ResourceContentHash(-1_980_341_351)
internal val Res.string.picso_task_react_title: StringResource by lazy {
      StringResource("string:picso_task_react_title", "picso_task_react_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3442, 82),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2438, 50),
      ))
    }

@delegate:ResourceContentHash(-2_062_063_767)
internal val Res.string.picso_task_save_body: StringResource by lazy {
      StringResource("string:picso_task_save_body", "picso_task_save_body", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3525, 156),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2489, 96),
      ))
    }

@delegate:ResourceContentHash(1_093_934_981)
internal val Res.string.picso_task_save_title: StringResource by lazy {
      StringResource("string:picso_task_save_title", "picso_task_save_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3682, 85),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2586, 53),
      ))
    }

@delegate:ResourceContentHash(-39_395_200)
internal val Res.string.picso_title: StringResource by lazy {
      StringResource("string:picso_title", "picso_title", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3768, 27),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2640, 27),
      ))
    }

@delegate:ResourceContentHash(2_073_145_788)
internal val Res.string.picso_views_count: StringResource by lazy {
      StringResource("string:picso_views_count", "picso_views_count", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_picso.commonMain.cvr", 3796, 61),
        ResourceItem(setOf(), "${MD}values/strings_picso.commonMain.cvr", 2668, 41),
      ))
    }

@delegate:ResourceContentHash(-262_993_637)
internal val Res.string.premium_active: StringResource by lazy {
      StringResource("string:premium_active", "premium_active", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 10, 62),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 10, 54),
      ))
    }

@delegate:ResourceContentHash(-190_044_963)
internal val Res.string.premium_back: StringResource by lazy {
      StringResource("string:premium_back", "premium_back", setOf(
        ResourceItem(setOf(LanguageQualifier("ru"), ), "${MD}values-ru/strings_premium.commonMain.cvr", 73, 36),
        ResourceItem(setOf(), "${MD}values/strings_premium.commonMain.cvr", 65, 28),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString5Resources(map: MutableMap<String, StringResource>) {
  map.put("groups_list_error_load_more", Res.string.groups_list_error_load_more)
  map.put("groups_list_error_search", Res.string.groups_list_error_search)
  map.put("groups_list_new_group", Res.string.groups_list_new_group)
  map.put("groups_list_search_empty_body", Res.string.groups_list_search_empty_body)
  map.put("groups_list_title", Res.string.groups_list_title)
  map.put("handle_prefixed", Res.string.handle_prefixed)
  map.put("link_error_body", Res.string.link_error_body)
  map.put("link_error_title", Res.string.link_error_title)
  map.put("link_loading", Res.string.link_loading)
  map.put("link_title", Res.string.link_title)
  map.put("moderation_action_desc_block_user", Res.string.moderation_action_desc_block_user)
  map.put("moderation_action_desc_delete_message", Res.string.moderation_action_desc_delete_message)
  map.put("moderation_action_desc_delete_permanent", Res.string.moderation_action_desc_delete_permanent)
  map.put("moderation_action_desc_delete_post", Res.string.moderation_action_desc_delete_post)
  map.put("moderation_confirm_head_block", Res.string.moderation_confirm_head_block)
  map.put("moderation_confirm_head_delete_account", Res.string.moderation_confirm_head_delete_account)
  map.put("moderation_confirm_head_delete_comment", Res.string.moderation_confirm_head_delete_comment)
  map.put("moderation_confirm_head_delete_group", Res.string.moderation_confirm_head_delete_group)
  map.put("moderation_confirm_head_delete_message", Res.string.moderation_confirm_head_delete_message)
  map.put("moderation_confirm_head_delete_post", Res.string.moderation_confirm_head_delete_post)
  map.put("moderation_confirm_head_delete_unknown", Res.string.moderation_confirm_head_delete_unknown)
  map.put("moderation_confirm_head_none", Res.string.moderation_confirm_head_none)
  map.put("moderation_confirm_tail_reject", Res.string.moderation_confirm_tail_reject)
  map.put("moderation_confirm_tail_resolve", Res.string.moderation_confirm_tail_resolve)
  map.put("mute_choice_eight_hours", Res.string.mute_choice_eight_hours)
  map.put("mute_choice_forever", Res.string.mute_choice_forever)
  map.put("mute_choice_one_day", Res.string.mute_choice_one_day)
  map.put("mute_choice_one_hour", Res.string.mute_choice_one_hour)
  map.put("mute_choice_one_week", Res.string.mute_choice_one_week)
  map.put("mute_status_indefinite", Res.string.mute_status_indefinite)
  map.put("mute_status_until_date", Res.string.mute_status_until_date)
  map.put("mute_status_until_today", Res.string.mute_status_until_today)
  map.put("mute_status_until_yesterday", Res.string.mute_status_until_yesterday)
  map.put("notifications_discover", Res.string.notifications_discover)
  map.put("notifications_discover_preview", Res.string.notifications_discover_preview)
  map.put("notifications_groups", Res.string.notifications_groups)
  map.put("notifications_mentions", Res.string.notifications_mentions)
  map.put("notifications_message_preview", Res.string.notifications_message_preview)
  map.put("notifications_messages", Res.string.notifications_messages)
  map.put("notifications_retry", Res.string.notifications_retry)
  map.put("notifications_security", Res.string.notifications_security)
  map.put("notifications_security_note", Res.string.notifications_security_note)
  map.put("notifications_streaks", Res.string.notifications_streaks)
  map.put("notifications_title", Res.string.notifications_title)
  map.put("notifications_unavailable", Res.string.notifications_unavailable)
  map.put("picso_action_archive", Res.string.picso_action_archive)
  map.put("picso_action_delete", Res.string.picso_action_delete)
  map.put("picso_action_reply", Res.string.picso_action_reply)
  map.put("picso_action_save", Res.string.picso_action_save)
  map.put("picso_action_saved", Res.string.picso_action_saved)
  map.put("picso_add_reaction", Res.string.picso_add_reaction)
  map.put("picso_analytics_title", Res.string.picso_analytics_title)
  map.put("picso_analytics_unique_views", Res.string.picso_analytics_unique_views)
  map.put("picso_archive_empty", Res.string.picso_archive_empty)
  map.put("picso_archive_title", Res.string.picso_archive_title)
  map.put("picso_button_snap", Res.string.picso_button_snap)
  map.put("picso_cancel", Res.string.picso_cancel)
  map.put("picso_caption_placeholder", Res.string.picso_caption_placeholder)
  map.put("picso_close", Res.string.picso_close)
  map.put("picso_confirm_delete", Res.string.picso_confirm_delete)
  map.put("picso_daily_limit_sub", Res.string.picso_daily_limit_sub)
  map.put("picso_daily_limit_title", Res.string.picso_daily_limit_title)
  map.put("picso_empty_feed", Res.string.picso_empty_feed)
  map.put("picso_empty_feed_sub", Res.string.picso_empty_feed_sub)
  map.put("picso_error_expired", Res.string.picso_error_expired)
  map.put("picso_error_limit_reached", Res.string.picso_error_limit_reached)
  map.put("picso_error_load", Res.string.picso_error_load)
  map.put("picso_load_more", Res.string.picso_load_more)
  map.put("picso_more", Res.string.picso_more)
  map.put("picso_no_chats", Res.string.picso_no_chats)
  map.put("picso_open_shared", Res.string.picso_open_shared)
  map.put("picso_publish_button", Res.string.picso_publish_button)
  map.put("picso_react_title", Res.string.picso_react_title)
  map.put("picso_reactions_count", Res.string.picso_reactions_count)
  map.put("picso_refresh", Res.string.picso_refresh)
  map.put("picso_remaining_time", Res.string.picso_remaining_time)
  map.put("picso_remove_reaction", Res.string.picso_remove_reaction)
  map.put("picso_report", Res.string.picso_report)
  map.put("picso_retake_button", Res.string.picso_retake_button)
  map.put("picso_retry", Res.string.picso_retry)
  map.put("picso_reward_posted", Res.string.picso_reward_posted)
  map.put("picso_reward_reacted", Res.string.picso_reward_reacted)
  map.put("picso_share", Res.string.picso_share)
  map.put("picso_shared_message", Res.string.picso_shared_message)
  map.put("picso_stat_unique", Res.string.picso_stat_unique)
  map.put("picso_stat_views", Res.string.picso_stat_views)
  map.put("picso_streak_badge", Res.string.picso_streak_badge)
  map.put("picso_tab_all", Res.string.picso_tab_all)
  map.put("picso_tab_friends", Res.string.picso_tab_friends)
  map.put("picso_tab_saved", Res.string.picso_tab_saved)
  map.put("picso_task_post_body", Res.string.picso_task_post_body)
  map.put("picso_task_post_title", Res.string.picso_task_post_title)
  map.put("picso_task_react_body", Res.string.picso_task_react_body)
  map.put("picso_task_react_title", Res.string.picso_task_react_title)
  map.put("picso_task_save_body", Res.string.picso_task_save_body)
  map.put("picso_task_save_title", Res.string.picso_task_save_title)
  map.put("picso_title", Res.string.picso_title)
  map.put("picso_views_count", Res.string.picso_views_count)
  map.put("premium_active", Res.string.premium_active)
  map.put("premium_back", Res.string.premium_back)
}
